export default import.meta.ROLLDOWN_FILE_URL_RpihXTw4u4VVDOtP81WECA